import type { UnknownAction } from '@reduxjs/toolkit'
import { 
  ADD_ASSET_TO_GROUP_SUCCEEDED,
  ADD_ASSET_TO_STREAM_SUCCEDDED,
  ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED,
  ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED,
  ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED,
  ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED,
  INVALIDATE_BACKGROUND_UPLOAD_TASK, 
  START_BACKGROUND_UPLOAD_TASK,
  CREATING_ASSET_FROM_FILE_SUCCEDDED,
  COLLECTION_ADD_ASSETS,
  DEAL_ROOM_ADD_ASSETS
} from '../actions/actionTypes'

import { BackgroundUploadTask, BackgroundUploadTaskRequest } from 'src/types/backgroundTask';
import { nanoid } from 'nanoid';
import { AddAssetToStreamSucceeded } from 'src/types/streams';
import { AddAssetToGroupSucceeded } from 'src/types/groups';
import { AddAssetToCollectionResponse } from 'src/types/collections';
import { AddAssetToConversationRequest } from 'src/types/conversations';
import { AddAssetToDealRoomRequest } from 'src/types/dealRoom';

interface TaskState {
  tasks: BackgroundUploadTask[];
}


const initialState: TaskState = {
  tasks: []
}

export function backgroundTasksReducer(state: TaskState = initialState, action: UnknownAction) : TaskState {
  switch (action.type) {
    case START_BACKGROUND_UPLOAD_TASK: {
      const task = action.payload as BackgroundUploadTaskRequest;
      const request = { 
        id: nanoid(),
        assets: task.assets,
        entity: task.entity
      }

      return {
        ...state,
        tasks: [...state.tasks, request]
      }
    }

    case INVALIDATE_BACKGROUND_UPLOAD_TASK: {
      const id = action.payload as string;
      const tasks = state.tasks.filter(task => task.id !== id);

      return {
        ...state,
        tasks: tasks
      }
    }

    case ADD_ASSET_TO_STREAM_SUCCEDDED: {
      const { streamId } = action.payload as AddAssetToStreamSucceeded;

      const tasks = (state.tasks || []).map(task => {
        const found = task.entity.entityType ==='stream' && task.entity.id === streamId;
        if(found){
          return {
            ...task,
            completed: true
          }
        }

        return task;
      }) || [];

      return {
        ...state,
        tasks: tasks
      };
    }

    case ADD_ASSET_TO_GROUP_SUCCEEDED: {
      const { groupId } = action.payload as AddAssetToGroupSucceeded;

      const tasks = (state.tasks || []).map(task => {
        const found = task.entity.entityType ==='group' && task.entity.id === groupId;
        if(found){
          return {
            ...task,
            completed: true
          }
        }

        return task;
      }) || [];

      return {
        ...state,
        tasks: tasks
      };
    }

    case ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED:
    case ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED: {
      const { collection } = action.payload as AddAssetToCollectionResponse;

      const tasks = (state.tasks || []).map(task => {
        const found = task.entity.entityType ==='collection' && task.entity.id === collection;
        if(found){
          return {
            ...task,
            completed: true
          }
        }

        return task;
      }) || [];

      return {
        ...state,
        tasks: tasks
      };
    }

    case ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED:
    case ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED: {
      const { conversation } = action.payload as AddAssetToConversationRequest;

      const tasks = (state.tasks || []).map(task => {
        const found = task.entity.entityType ==='conversation' && task.entity.id === conversation;
        if(found){
          return {
            ...task,
            completed: true
          }
        }

        return task;
      }) || [];

      return {
        ...state,
        tasks: tasks
      };
    }

    case CREATING_ASSET_FROM_FILE_SUCCEDDED: {
      const response = action.payload as any;

      const updatedTasks = state.tasks.map((task) => {
        const updatedAssets = task.assets.map((asset) => {
          if (asset.id === response.id) {
            return {
              ...asset,
              type: "asset",
              asset: response.response
            }; 
          }
          return asset; 
        });

        return {
          ...task,
          assets: updatedAssets
          };
        });

        return {
          ...state,
          tasks: updatedTasks
          };
      }
    
    case COLLECTION_ADD_ASSETS: {

      const response = action.payload as any;
      const collection = response.collection || response.id;
      const assets = response.assets;

      const tasks = state.tasks.map((task) => {
        if (task.entity.entityType == "collection" && task.entity.id == collection) {
          return {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  item.synced ||
                  assets.find((a) => a.id == item?.asset?.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          };
        }

        return task;
      });

      return {
        ...state,
        tasks: tasks
      }
    }

    case DEAL_ROOM_ADD_ASSETS: {
      const { dealRoom, assets } = action.payload as AddAssetToDealRoomRequest;

      const tasks = state.tasks.map((task) => {
        if (task.entity.entityType == "deal_room" && task.entity.id == dealRoom) {
          return {
            ...task,
            assets: task.assets.map((item) => {
              if (item && item.type == "asset") {
                var synced =
                  item.synced ||
                  assets.find((a) => a.id == item?.asset?.id) != null;
                return {
                  ...item,
                  synced: synced,
                };
              }

              return item;
            }),
          };
        }

        return task;
      });

      return {
        ...state,
        tasks: tasks
      }
    }

    default: {
      return state
    }
  }
}